/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export var FlowRunState;
(function (FlowRunState) {
    FlowRunState["SCHEDULED"] = "SCHEDULED";
    FlowRunState["PENDING"] = "PENDING";
    FlowRunState["RUNNING"] = "RUNNING";
    FlowRunState["COMPLETED"] = "COMPLETED";
    FlowRunState["FAILED"] = "FAILED";
    FlowRunState["CANCELLED"] = "CANCELLED";
    FlowRunState["CRASHED"] = "CRASHED";
    FlowRunState["PAUSED"] = "PAUSED";
    FlowRunState["CANCELLING"] = "CANCELLING";
})(FlowRunState || (FlowRunState = {}));
export const FLOW_RUNNING_STATUSES = [
    FlowRunState.RUNNING,
    FlowRunState.SCHEDULED,
    FlowRunState.CANCELLING,
    FlowRunState.PENDING,
];
export const FLOW_FAILED_STATUSES = [FlowRunState.FAILED, FlowRunState.CRASHED];
//# sourceMappingURL=flow-runs.js.map